import classNames from 'classnames';
import { Tooltip } from 'lib/components/Tooltip';
import { QuestionMarkCircleIcon } from '@heroicons/react/24/outline';
import FormSwitch from './publisher/FormSwitch';

// TODO: This component should be absorbed into a single "Organization Settings Info" component
// and state should be managed locally there, not via the database state.
type OrganizationSearchSettingToggleProps = {
  value: boolean;
  onChange: (value: boolean) => void;
};
export default function OrganizationSearchSettingToggle({
  value,
  onChange
}: OrganizationSearchSettingToggleProps) {
  return (
    <div
      className={classNames(
        'flex items-center justify-between h-12 w-full p-4 mt-4 rounded-md bg-white',
        {
          'border border-primary-500': value,
          'border border-grey-200': !value
        }
      )}
    >
      <div
        className={classNames('text-sm font-medium flex items-center', {
          'text-primary-500': value,
          'text-grey-400': !value
        })}
      >
        <Tooltip
          helpText="If enabled, this organization will appear when users search for existing
        organizations to join on Column. Keep this turned on if colleagues may
        need access to your notices."
          customPosition="-mt-40"
        >
          <QuestionMarkCircleIcon className="h-4 w-4 stroke-2" />
        </Tooltip>

        <p className="pl-2">Allow new users to find my organization</p>
      </div>
      <FormSwitch checked={value} onChange={() => onChange(!value)} />
    </div>
  );
}
